export default __webpack_public_path__ + "static/media/DNo.7-0.274385ff.jpg";